import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Button,
  CircularProgress,
  Alert,
  IconButton,
  AppBar,
  Toolbar
} from '@mui/material';
import {
  ArrowBack,
  Download,
  Fullscreen
} from '@mui/icons-material';
import axios from '../api/client';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8004';

const DocumentViewer = () => {
  const { documentId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [documentUrl, setDocumentUrl] = useState('');

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setLoading(true);
        // For now, we'll use a mock URL - in production this would be the actual API call
        const url = `${API_BASE_URL}/document/${documentId}`;
        setDocumentUrl(url);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching document:', error);
        setError('Failed to load document');
        setLoading(false);
      }
    };

    fetchDocument();
  }, [documentId]);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = documentUrl;
    link.download = `document_${documentId}.pdf`;
    link.click();
  };

  const handleFullscreen = () => {
    const iframe = document.getElementById('pdf-viewer');
    if (iframe.requestFullscreen) {
      iframe.requestFullscreen();
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/data')}
        >
          Back to Data
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/data')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Document Viewer - ID: {documentId}
          </Typography>
          <IconButton color="inherit" onClick={handleDownload}>
            <Download />
          </IconButton>
          <IconButton color="inherit" onClick={handleFullscreen}>
            <Fullscreen />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ mt: 2, height: 'calc(100vh - 200px)' }}>
        <Paper sx={{ height: '100%', overflow: 'hidden' }}>
          <iframe
            id="pdf-viewer"
            src={`${documentUrl}#toolbar=1&navpanes=1&scrollbar=1`}
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            title="PDF Document Viewer"
          />
        </Paper>
      </Box>

      <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          onClick={() => navigate('/data')}
        >
          Back to Data
        </Button>
        <Button
          variant="contained"
          startIcon={<Download />}
          onClick={handleDownload}
        >
          Download PDF
        </Button>
      </Box>
    </Box>
  );
};

export default DocumentViewer; 